import ButtonNew from "../ButtonNew/index";

/** Vendors **/

/** Components **/

/** ========== **/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const TawkToButton = ({ children, ...props }) => {
  return (
    <ButtonNew
      onClick={async () => {
        await Tawk_API.toggle();
      }}
      {...props}
    >
      {children || "Talk To Our Expert Now"}
    </ButtonNew>
  );
};

export default TawkToButton;
